<template>
  <div class="main" id="Adresses">
    <Header :From="'Profile'" id="Header" />
    <CContainer class="d-flex content-center min-vh-90" id="container">
      <div class="row p-0 m-0">
        <div class="col-lg-4 col-md-4 col-sm-12"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 p-0 m-0 box account-box">
          <div class="title">
            <img src="/icons_2/prev.png" alt="" @click="$router.go(-1)" />
            <span> {{ $t("Address.MyAddress") }} </span>
          </div>
          <div class="addresses">
            <div class="load" v-if="loading">
              <CIcon name="cil-cart" height="48" />
            </div>
            <div
              class="address"
              v-for="(address, index) in addresses"
              :key="address.id"
              v-show="!adding_new_address && !update_address"
            >
              <div class="addresses-top">
                <span class="item-title"
                  >{{ $t("Address.Nbre") }}{{ index + 1 }}:</span
                >
                <div style="display: flex;">
                  <button
                    class="button-delete delete-address"
                    style="margin-right: 40px;"
                    @click="
                      update_address = true;
                      addressToUpdate = address;
                    "
                  >
                    <font-awesome-icon class="faIcon" icon="pen" />
                  </button>
                  <button
                    class="button-delete delete-address"
                    @click="deleteConfirm(address)"
                  >
                    <font-awesome-icon class="faIcon" icon="times" />
                  </button>
                </div>
              </div>
              <hr />
              <div class="input-div">
                <div>
                  <label position="floating">{{ $t("Address.Name") }}:</label>
                  <input
                    class="input"
                    :value="address.building_name"
                    readonly
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Address") }}:</label
                  >
                  <input class="input" :value="address.line_1" readonly />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Gouvernorate") }}:</label
                  >
                  <input class="input" :value="address.region" readonly />
                </div>
                <div>
                  <label position="floating">{{ $t("Address.City") }}:</label>
                  <input class="input" :value="address.city" readonly />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.PostalCode") }}:</label
                  >
                  <input class="input" :value="address.postcode" readonly />
                </div>
              </div>
            </div>

            <div class="address new_address" v-show="adding_new_address">
              <div
                class="addresses-top"
                style="font-weight: bold;color: green;"
              >
                <span class="item-title">
                  <font-awesome-icon class="faIcon" icon="plus" />
                  {{ $t("Button.AddAddress") }}
                </span>
              </div>
              <hr />
              <div class="input-div">
                <div>
                  <label position="floating">{{ $t("Address.Name") }}:</label>
                  <input
                    class="input"
                    v-model="new_address.building_name"
                    :placeholder="$t('Address.Example')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Address") }}:</label
                  >
                  <input
                    class="input"
                    v-model="new_address.address"
                    :placeholder="$t('Address.EnterAdd')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Gouvernorate") }}:</label
                  >
                  <input
                    class="input"
                    v-model="new_address.gouv"
                    :placeholder="$t('Address.EnterGov')"
                  />
                </div>
                <div>
                  <label position="floating">{{ $t("Address.City") }}:</label>
                  <input
                    class="input"
                    v-model="new_address.city"
                    :placeholder="$t('Address.EnterCity')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.PostalCode") }}:</label
                  >
                  <input
                    class="input"
                    v-model="new_address.postal"
                    :placeholder="$t('Address.EnterPost')"
                  />
                </div>

                <div class="row mt-3">
                  <div class="col-6" @click="addNewAddress()">
                    <button class="btn btn-success" style="width: 100%">
                      <font-awesome-icon class="faIcon" icon="plus" />
                      {{ $t("Button.Add") }}
                    </button>
                  </div>
                  <div class="col-6" @click="reset()">
                    <button class="btn btn-danger" style="width: 100%">
                      <font-awesome-icon class="faTimes" icon="plus" />
                      {{ $t("Button.Cancel") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- update interface -->
            <div class="address-update" v-show="update_address">
              <div class="input-div">
                <div>
                  <label position="floating">{{ $t("Address.Name") }}:</label>
                  <input
                    class="input"
                    v-model="addressToUpdate.building_name"
                    :placeholder="$t('Address.Example')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Address") }}:</label
                  >
                  <input
                    class="input"
                    v-model="addressToUpdate.line_1"
                    :placeholder="$t('Address.EnterAdd')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.Gouvernorate") }}:</label
                  >
                  <input
                    class="input"
                    v-model="addressToUpdate.region"
                    :placeholder="$t('Address.EnterGov')"
                  />
                </div>
                <div>
                  <label position="floating">{{ $t("Address.City") }}:</label>
                  <input
                    class="input"
                    v-model="addressToUpdate.city"
                    :placeholder="$t('Address.EnterCity')"
                  />
                </div>
                <div>
                  <label position="floating"
                    >{{ $t("Address.PostalCode") }}:</label
                  >
                  <input
                    class="input"
                    v-model="addressToUpdate.postcode"
                    :placeholder="$t('Address.EnterPost')"
                  />
                </div>

                <div class="row mt-3">
                  <div class="col-6" @click="updateAddress()">
                    <button class="btn btn-success" style="width: 100%">
                      <font-awesome-icon class="faIcon" icon="pen" />
                      {{ $t("Button.UpdateAddress") }}
                    </button>
                  </div>
                  <div class="col-6" @click="update_address = false">
                    <button class="btn btn-danger" style="width: 100%">
                      <font-awesome-icon class="faTimes" icon="times" />
                      {{ $t("Button.Cancel") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CRow
              style="margin-top: 10px;"
              v-show="!adding_new_address"
              @click="
                adding_new_address = true;
                update_address = false;
              "
            >
              <CCol col="12" class="text-left">
                <CButton
                  type="submit"
                  color="primary"
                  class="px-4 w-100 button-add-address"
                >
                  <font-awesome-icon class="faIcon" icon="plus" />
                  {{ $t("Button.AddAddress") }}
                </CButton>
              </CCol>
            </CRow>
          </div>
        </div>
      </div>
      <vue-confirm-dialog></vue-confirm-dialog>
    </CContainer>
  </div>
</template>

<script>
import { userService } from "../../../_services";
import Header from "../../../components/Header.vue";

export default {
  name: "Swiper",
  components: {
    Header,
  },
  data: () => ({
    loading: false,
    user: {
      name: "",
      phone: "",
      email: "",
    },
    offset: 0,
    collapsePrefences: true,
    collapseAccount: false,
    addresses: [],
    addressToUpdate: {},
    adding_new_address: false,
    update_address: false,
    new_address: {
      address: null,
      gouv: null,
      city: null,
      postal: null,
      building_name: null,
    },
    selected_address: {
      name: null,
      id: null,
    },
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("shop_user"));
  },
  methods: {
    addNewAddress() {
      let loader = this.$loading.show();
      let data = {
        line_1: this.new_address.address,
        building_name: this.new_address.building_name,
        region: this.new_address.gouv,
        city: this.new_address.city,
        postcode: this.new_address.postal,
      };

      userService
        .addAddress(data)
        .then(
          function(data) {
            // this.toasts.add_success = true;
            this.addresses = data.addresses.addresses;
            this.reset();
            if (this.$route.query.from) {
              this.$router.push(
                "/shop/cart?action=address_added&new_address=" +
                  this.addresses[this.addresses.length - 1].id
              );
            }
          }.bind(this)
        )
        .catch(
          function() {
            // this.toasts.add_error = true;
          }.bind(this)
        )
        .finally(
          function() {
            loader.hide();
          }.bind(this)
        );
    },
    updateAddress() {
      let loader = this.$loading.show();
      let data = {
        line_1: this.addressToUpdate.line_1,
        building_name: this.addressToUpdate.building_name,
        region: this.addressToUpdate.region,
        city: this.addressToUpdate.city,
        postcode: this.addressToUpdate.postcode,
      };

      userService
        .updateAddress(this.addressToUpdate.id, data)
        .then(
          function(data) {
            // this.toasts.add_success = true;
            this.addresses = data.addresses.addresses;
            this.reset();
            if (this.$route.query.from) {
              this.$router.push(
                "/shop/cart?action=address_added&new_address=" +
                  this.addresses[this.addresses.length - 1].id
              );
            }
          }.bind(this)
        )
        .catch(
          function() {
            // this.toasts.add_error = true;
          }.bind(this)
        )
        .finally(
          function() {
            loader.hide();
            this.update_address = false;
          }.bind(this)
        );
    },
    reset() {
      this.adding_new_address = false;
      this.new_address = {
        address: null,
        gouv: null,
        city: null,
        postal: null,
        building_name: null,
      };
    },
    deleteConfirm(address) {
      this.selected_address = address;
      this.$confirm({
        message: `Confirmation`,
        message:
          "êtes-vous sûr de supprimer l'adresse '" +
          this.selected_address.building_name +
          "'?",
        button: {
          no: "Annuler",
          yes: "Supprimer",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            this.deleteAddress();
          }
        },
      });
    },
    deleteAddress() {
      let loader = this.$loading.show();
      userService
        .deleteAddress(this.selected_address.id)
        .then(
          function(data) {
            // this.toasts.delete_success = true;
            this.addresses = data.addresses.addresses;
          }.bind(this)
        )
        .catch(
          function() {
            // this.toasts.add_error = true;
          }.bind(this)
        )
        .finally(
          function() {
            loader.hide();
          }.bind(this)
        );
    },
  },

  mounted() {
    let loader = this.$loading.show();
    if (this.$route.query.from) {
      this.adding_new_address = true;
    }

    userService
      .getAddresses()
      .then(
        function(data) {
          console.log(data);
          this.addresses = data.addresses;
        }.bind(this)
      )
      .finally(
        function() {
          loader.hide();
        }.bind(this)
      );
  },
};
</script>
<style lang="scss" scoped>
#Adresses {
  .account-box {
    background: #fff;
  }
  .box {
    background: #fff;
    width: 100%;
    width: 50vw;
    margin-top: 70px !important;
    margin-left: 15px !important;
    box-shadow: 0 0 8px 1px #ddd;
    margin-bottom: 30px !important;
  }

  .title {
    letter-spacing: 2px;
    font-size: 20px;
    padding: 10px;
    border-bottom: 2px solid #ddd;
    color: #666;
  }
  .title img {
    float: left;
    width: 30px;
    margin-top: 5px;
  }
  .addresses {
    text-align: left;
    background: #eee;
    padding: 10px;
  }
  .subtitle {
    font-size: 15px;
    letter-spacing: 1px;
    font-weight: bold;
    display: block;
    padding: 0 0 0 10px;
    text-transform: uppercase;
    transition: 0.3s;
  }
  .address {
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    margin-bottom: 10px;
  }

  .address-update {
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    color: var(--primary);
    margin-bottom: 10px;
  }
  .addresses-top {
    position: relative;
    margin-top: -10px;
  }
  .addresses-top span {
    display: inline-block;
  }
  .addresses-top button {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-top: -5px;
    color: #fff;
    border: none;
    border-radius: 0 10px 0 5px;
    position: absolute;
    right: -20px;
    top: -5px;
    outline: none;
  }
  .button-delete {
    background: #ef86c1;
    &:hover {
      background: darken(#ef86c1, 10%);
    }
  }
  .input-div {
    padding: 0 10px;
  }
  .input-div div {
    margin-top: 5px;
  }
  .input-div label {
    display: block;
  }
  .input-div input {
    display: block;
    width: 100%;
    border: 1px solid #eee;
    height: 30px;
    padding: 0 10px;
    border-radius: 5px;
  }
  @media screen and (max-width: 720px) {
    .box {
      width: 100vw;
      max-width: 100vw;
      position: absolute;
      transform: translate(-50%);
      margin-top: 0px !important;
      box-shadow: 0 0 0 0 #ddd;
    }
    #Header {
      display: none;
    }
    .title {
      color: #ef86c1 !important;
    }
    .title img {
      display: inline-block;
    }
  }
  .button-add-address {
    background: #ef86c1;
    border-color: #ef86c1;
    &:hover {
      background: darken(#ef86c1, 10%);
    }
  }
}
</style>
